import React from 'react';
import moment from 'moment';

import { useIsLoggedInQuery } from '../../redux/apis/authApi';

import { ROLES } from '../../utils/constant/global';
import { timeStampFormatDate } from '../../utils/handler';

const { ADMIN, HR } = ROLES;

const isOngoing = (end) => !end || Number(end) === 0;

const toMoment = (value) => moment(Number.isNaN(Number(value)) ? value : Number(value));

export const toSortTime = (value) => toMoment(value).valueOf() || 0;

const formatDuration = (start, end) => {
  if (!start) return '';
  const startMoment = toMoment(start);
  const endMoment = isOngoing(end) ? moment() : toMoment(end);
  if (!startMoment.isValid() || !endMoment.isValid()) return '';
  const totalMonths = Math.max(endMoment.diff(startMoment, 'months'), 1);
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  return [
    years ? `${years} yr${years > 1 ? 's' : ''}` : '',
    months ? `${months} mo${months > 1 ? 's' : ''}` : ''
  ]
    .filter(Boolean)
    .join(' ');
};

function ProfileTimelineCard({ title, icon, itemIcon, items, emptyText, onClickEdit }) {
  const { data: authData } = useIsLoggedInQuery();
  const list = items || [];

  return (
    <div className="card h-100 ep-info-card ep-timeline-card">
      <div className="card-header py-3 d-flex justify-content-between align-items-center">
        <div className="ep-info-card__title">
          <span className="ep-info-card__title-icon" aria-hidden>
            <i className={`bi ${icon}`} />
          </span>
          <h6 className="mb-0 fw-bold">{title}</h6>
          {list.length ? <span className="ep-info-card__count">{list.length}</span> : null}
        </div>
        {[ADMIN, HR].includes(authData?.data?.hrxRole?.roleName) && (
          <button type="button" className="btn p-0" onClick={onClickEdit}>
            <i className="icofont-edit text-primary fs-6"></i>
          </button>
        )}
      </div>

      <div className="card-body">
        {!list.length ? (
          <div className="ep-timeline-empty">
            <span className="ep-timeline-empty__icon" aria-hidden>
              <i className={`bi ${icon}`} />
            </span>
            <span>{emptyText}</span>
          </div>
        ) : (
          <ul className="ep-timeline">
            {list.map((item) => {
              const ongoing = isOngoing(item.end);
              const duration = formatDuration(item.start, item.end);
              return (
                <li
                  key={item.key}
                  className={`ep-timeline__item${ongoing ? ' ep-timeline__item--current' : ''}`}
                >
                  <span className="ep-timeline__marker" aria-hidden>
                    <i className={`bi ${itemIcon}`} />
                  </span>
                  <div className="ep-timeline__content">
                    <div className="ep-timeline__head">
                      <span className="ep-timeline__title" title={item.title}>
                        {item.title || '-'}
                      </span>
                      {ongoing ? <span className="ep-timeline__badge">Current</span> : null}
                    </div>
                    {item.subtitle ? (
                      <span className="ep-timeline__subtitle">{item.subtitle}</span>
                    ) : null}
                    <div className="ep-timeline__meta">
                      <span className="ep-timeline__date">
                        <i className="bi bi-calendar" aria-hidden />
                        {`${item.start ? timeStampFormatDate(item.start, 'MMM YYYY') : '-'} - ${
                          ongoing ? 'Present' : timeStampFormatDate(item.end, 'MMM YYYY')
                        }`}
                      </span>
                      {duration ? <span className="ep-timeline__duration">{duration}</span> : null}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default ProfileTimelineCard;
